import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './statistics_show.routes';
import moment from 'angular-moment';

import SaConfigService from "../../../components/api/sa_config/sa_config.service";
import MonthlyActivePowerService from '../../../components/api/monthly_active_power/monthly_active_power.service';
import MonthlyMaxDemandPowerService from '../../../components/api/monthly_max_demand_power/monthly_max_demand_power.service';
import EventService from '../../../components/api/event/event.service';
import DailyActivePowerService from '../../../components/api/daily_active_power/daily_active_power.service';
import ActivePowerService from '../../../components/api/active_power/active_power.service';
import DailyWeatherService from '../../../components/api/daily_weather/daily_weather.service';
import DailyMaxDemandPowerService from '../../../components/api/daily_max_demand_power/daily_max_demand_power.service';
import DemandPowerService from '../../../components/api/demand_power/demand_power.service';

import DateUtil from '../../../components/logic/date_util/date_util.module';

export class StatisticsShowController {
  /*@ngInject*/
  constructor($stateParams, $state, moment, $q,
              SaConfigService, MonthlyActivePowerService, MonthlyMaxDemandPowerService, EventService,
              DailyActivePowerService, ActivePowerService, DailyWeatherService, DailyMaxDemandPowerService,
              DemandPowerService, DateUtil) {
    this.SaConfigService = SaConfigService;
    this.MonthlyActivePowerService = MonthlyActivePowerService;
    this.MonthlyMaxDemandPowerService = MonthlyMaxDemandPowerService;
    this.EventService = EventService;
    this.DailyActivePowerService = DailyActivePowerService;
    this.ActivePowerService = ActivePowerService;
    this.DailyWeatherService = DailyWeatherService;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;
    this.DemandPowerService = DemandPowerService;
    this.DateUtil = DateUtil;

    this.id = $stateParams.id;
    this.moment = moment;
    this.$q = $q;

    this.targetDate = this.moment().startOf('month').subtract(1, 'month');
    this.saInfo = null;
    this.data = {};

    this.saInfoPromise = null;
  }

  $onInit() {
    this.saInfoPromise = this.SaConfigService.api.show({id: this.id}).$promise;
    this.saInfoPromise.then(res => {
      this.saInfo = res;
    });
    this.updateData(this.targetDate);
  }

  changeMonth(diff) {
    this.targetDate.add(diff, 'month');
    this.updateData(this.targetDate);
  }

  updateData(targetDate) {
    this.data.targetDate = targetDate;

    const eventQuery = this.eventQuery(targetDate);
    this.$q.all([
      this.EventService.api.show(eventQuery.current).$promise,
      this.EventService.api.show(eventQuery.before).$promise
    ]).then(responses => {
      this.data.events = {
        current: responses[0],
        before: responses[1]
      };
    });

    const dailyPowerQuery = this.dailyPowerQuery(targetDate);
    const dailyWeatherQuery = this.dailyWeatherQuery(targetDate);
    this.$q.all([
      this.DailyActivePowerService.show(dailyPowerQuery.current).$promise,
      this.DailyActivePowerService.show(dailyPowerQuery.before).$promise,
      this.DailyWeatherService.api.index(dailyWeatherQuery.current).$promise
    ]).then(responses => {
      this.data.dailyActivePower = {
        current: responses[0].powers,
        before: responses[1].powers,
        currentWeather: responses[2]
      };
    });

    this.$q.all([
      this.DailyMaxDemandPowerService.show(dailyPowerQuery.current).$promise,
      this.DailyMaxDemandPowerService.show(dailyPowerQuery.before).$promise
    ]).then(responses => {
      this.data.dailyMaxDemandPower = {
        current: responses[0].powers,
        before: responses[1].powers
      }
    });

    const hourlyPowerQuery = this.hourlyPowerQuery(targetDate);
    this.$q.all([
      this.DemandPowerService.show(hourlyPowerQuery.current).$promise,
      this.DemandPowerService.show(hourlyPowerQuery.before).$promise
    ]).then(responses => {
      this.data.demandPower = {
        current: responses[0].powers,
        before: responses[1].powers
      }
    });
  }

  eventQuery(targetDate) {
    const beforeDate = targetDate.clone().subtract(1, 'month');
    return {
      current: {
        id: this.id,
        year: targetDate.year(),
        month: targetDate.month() + 1
      },
      before: {
        id: this.id,
        year: beforeDate.year(),
        month: beforeDate.month() + 1
      }
    }
  }

  dailyPowerQuery(targetDate) {
    const endDate = targetDate.clone().endOf('month');
    const startDate = targetDate;
    const beforeStartDate = targetDate.clone().subtract(1, 'month');
    const beforeEndDate = targetDate.clone().subtract(1, 'month').endOf('month');

    return {
      current: angular.extend({id: this.id}, this.DateUtil.datetimeRangeQuery(startDate, endDate)),
      before: angular.extend({id: this.id}, this.DateUtil.datetimeRangeQuery(beforeStartDate, beforeEndDate))
    }
  }

  dailyWeatherQuery(targetDate) {
    const endDate = targetDate.clone().endOf('month');
    const startDate = targetDate;
    const beforeStartDate = targetDate.clone().subtract(1, 'month');
    const beforeEndDate = targetDate.clone().subtract(1, 'month').endOf('month');

    return {
      current: angular.extend({sa_config_id: this.id}, this.DateUtil.datetimeRangeQuery(startDate, endDate)),
      before: angular.extend({sa_config_id: this.id}, this.DateUtil.datetimeRangeQuery(beforeStartDate, beforeEndDate))
    }
  }

  hourlyPowerQuery(targetDate) {
    const startDate = targetDate.clone().startOf('month');
    const endDate = targetDate.clone().add(1, 'month').startOf('month');
    const beforeStartDate = targetDate.clone().subtract(1, 'month');
    const beforeEndDate = startDate;

    return {
      current: angular.extend({id: this.id}, this.DateUtil.datetimeRangeQuery(startDate, endDate)),
      before: angular.extend({id: this.id}, this.DateUtil.datetimeRangeQuery(beforeStartDate, beforeEndDate))
    }
  }
}

export default angular.module('leptonApp.statisticsShow',
  [moment, uiRouter, SaConfigService, MonthlyActivePowerService, MonthlyMaxDemandPowerService, EventService,
    DailyActivePowerService, ActivePowerService, DailyWeatherService, DailyMaxDemandPowerService,
    DemandPowerService, DateUtil])
  .config(routing)
  .component('statisticsShow', {
    template: require('./statistics_show.html'),
    controller: StatisticsShowController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/show/statistics_show.component.js